module.exports = __webpack_public_path__ + "img/lms-reason-5.bd837835.png";